import React from 'react';
import Helmet from "react-helmet";

const OpenGraph = ({ pageTitle, pageDescription, pageImage }) => {
  return (
    <Helmet>
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:image" content={pageImage} />
    </Helmet>
  );
};

export default OpenGraph;
